import React from 'react';
import { ShiftPreferencesModal } from '@/shared/ui/components';

const ModalContext = React.createContext({});

export const ModalProvider = ({ children, showOnMount = false }) => {
  const [show, setShow] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [settings, setSettings] = React.useState({
    forEdit: false,
    initialSlide: 0,
    initialValues: null,
    onSubmit: null,
  });

  const open = (newSettings) => {
    setSettings((state) => ({ ...state, ...newSettings }));
    setSubmitted(false);
    setShow(true);
  };

  const close = () => setShow(false);

  React.useEffect(() => {
    if (showOnMount) {
      setShow(true);
    }
  }, [showOnMount]);

  return (
    <ModalContext.Provider
      value={{
        submitted,
        actions: { open, close, setSubmitted },
      }}
    >
      <ShiftPreferencesModal show={show} {...settings} />
      {children}
    </ModalContext.Provider>
  );
};

export const useModalControl = () => React.useContext(ModalContext);
